import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  Home,
  TentangKami,
  Fasilitas,
  PusatMedia,
  Pengumuman,
  HubungiKami,
  DisekitarKami,
  ResetPassword,
  JalanTolKami,
  RuangBerita,
} from '../pages';
import PrivateRoute from './PrivateRoute';
import {
  Login,
  Fasilitas as DashboardFasilitas,
  HubungiKami as DashboardHubungiKami,
  Pengumuman as DashboardPengumuman,
  RuangBerita as DashboardRuangBerita,
  TentangKami as DashboardTentangKami,
  JalanTolKami as DashboardJalanTolKami,
  Images as DashboardImages,
} from '../pages/Dashboard';
import { LayoutDashboard, LayoutLandingPages } from '../components';

const RouteLandingPage = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/tentang-kami',
    component: TentangKami,
    exact: false,
  },
  {
    path: '/tentang-kami/*',
    component: TentangKami,
    exact: false,
  },
  {
    path: '/jalan-tol-kami',
    component: JalanTolKami,
    exact: false,
  },
  {
    path: '/jalan-tol-kami/*',
    component: JalanTolKami,
    exact: false,
  },
  {
    path: '/ruang-berita',
    component: RuangBerita,
    exact: false,
  },
  {
    path: '/ruang-berita/*',
    component: RuangBerita,
    exact: false,
  },
  {
    path: '/fasilitas',
    component: Fasilitas,
    exact: false,
  },
  {
    path: '/fasilitas/*',
    component: Fasilitas,
    exact: false,
  },
  {
    path: '/pusat-media',
    component: PusatMedia,
    exact: false,
  },
  {
    path: '/pusat-media/*',
    component: PusatMedia,
    exact: false,
  },
  {
    path: '/pengumuman',
    component: Pengumuman,
    exact: false,
  },
  {
    path: '/pengumuman/*',
    component: Pengumuman,
    exact: false,
  },
  {
    path: '/hubungi-kami',
    component: HubungiKami,
    exact: false,
  },
  {
    path: '/disekitar-kami',
    component: DisekitarKami,
    exact: false,
  },
  {
    path: '/disekitar-kami/*',
    component: DisekitarKami,
    exact: false,
  },
];

const RouteDashboard = [
  {
    path: '/dashboard',
    component: DashboardTentangKami,
    exact: true,
  },
  {
    path: '/dashboard/jalan-tol-kami',
    component: DashboardJalanTolKami,
    exact: false,
  },
  {
    path: '/dashboard/ruang-berita',
    component: DashboardRuangBerita,
    exact: false,
  },
  {
    path: '/dashboard/fasilitas',
    component: DashboardFasilitas,
    exact: false,
  },
  {
    path: '/dashboard/hubungi-kami',
    component: DashboardHubungiKami,
    exact: false,
  },
  {
    path: '/dashboard/lainnya',
    component: DashboardHubungiKami,
    exact: false,
  },
  {
    path: '/dashboard/pengumuman',
    component: DashboardPengumuman,
    exact: false,
  },

  {
    path: '/dashboard/Images',
    component: DashboardImages,
    exact: false,
  },
];

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path={RouteLandingPage.map((r) => r.path)}>
          <LayoutLandingPages>
            {RouteLandingPage.filter(
              (r) => r.path[r.path.length - 1] !== '*'
            ).map((r, i) => (
              <Route
                exact={r.exact}
                path={r.path}
                key={i}
                component={r.component}
              />
            ))}
          </LayoutLandingPages>
        </Route>
        <Route exact path='/reset-password/:token' component={ResetPassword} />
        <Route exact path='/dashboard/login' component={Login} />
        <Route path={RouteDashboard.map((r) => r.path)}>
          <LayoutDashboard>
            {RouteDashboard.filter(
              (r) => r.path[r.path.length - 1] !== '*'
            ).map((r, i) => (
              <PrivateRoute
                exact={r.exact}
                path={r.path}
                key={i}
                component={r.component}
              />
            ))}
          </LayoutDashboard>
        </Route>
      </Switch>
    </Router>
  );
};

export default Routes;
